export default __webpack_public_path__ + "static/media/3d-object-min.944701a4.png";